import { format } from 'date-fns';
import { Badge } from '../../../design-system/components/Badge';
import { Button } from '../../../design-system/components/Button';
import { Card } from '../../../design-system/components/Card';
import type { KnowledgeDocument } from '../api';
import { useDeleteKnowledge, useReindexKnowledge } from '../hooks';
import {
  formatFileSize,
  formatKnowledgeDocType,
  formatKnowledgeStatus,
  type KnowledgeStatus,
} from '../status';

interface KnowledgeTableProps {
  docs: readonly KnowledgeDocument[];
  canAdmin: boolean;
}

const STATUS_VARIANT: Record<
  KnowledgeStatus,
  'neutral' | 'accent' | 'success' | 'warning' | 'danger'
> = {
  pending: 'neutral',
  processing: 'accent',
  indexed: 'success',
  failed: 'danger',
};

export function KnowledgeTable({ docs, canAdmin }: KnowledgeTableProps) {
  const del = useDeleteKnowledge();
  const reindex = useReindexKnowledge();

  return (
    <Card>
      <table className="dash-table" aria-label="Documentos da base">
        <thead>
          <tr>
            <th scope="col">Arquivo</th>
            <th scope="col">Categoria</th>
            <th scope="col">Status</th>
            <th scope="col">Tamanho</th>
            <th scope="col">Enviado em</th>
            {canAdmin ? <th scope="col">Ações</th> : null}
          </tr>
        </thead>
        <tbody>
          {docs.map((d) => (
            <tr key={d.id}>
              <td>{d.filename}</td>
              <td>{formatKnowledgeDocType(d.doc_type)}</td>
              <td>
                <Badge variant={STATUS_VARIANT[d.status]}>{formatKnowledgeStatus(d.status)}</Badge>
              </td>
              <td>{formatFileSize(d.file_size ?? null)}</td>
              <td>{format(new Date(d.created_at), 'dd/MM/yyyy HH:mm')}</td>
              {canAdmin ? (
                <td>
                  <div className="dash-table__actions">
                    <Button
                      variant="ghost"
                      onClick={() => reindex.mutate(d.id)}
                      isLoading={reindex.isPending && reindex.variables === d.id}
                    >
                      Reindexar
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => del.mutate(d.id)}
                      isLoading={del.isPending && del.variables === d.id}
                    >
                      Excluir
                    </Button>
                  </div>
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}
